import { render, staticRenderFns } from "./mouth.vue?vue&type=template&id=fbb06626&scoped=true"
import script from "./mouth.vue?vue&type=script&lang=js"
export * from "./mouth.vue?vue&type=script&lang=js"
import style0 from "./mouth.vue?vue&type=style&index=0&id=fbb06626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb06626",
  null
  
)

export default component.exports